type Flag = 'off' | 'pilot' | 'on';

const flag = (k: string, d: Flag = 'pilot'): Flag =>
  ((import.meta.env?.[k] as any) || d) as Flag;

export const sponsorsEnabled = () =>
  (import.meta.env?.VITE_FEATURE_SPONSORS || 'pilot') !== 'off';
export const nominationsEnabled = () => flag('VITE_FEATURE_NOMINATIONS') !== 'off';
export const storybooksEnabled = () => flag('VITE_FEATURE_STORYBOOKS') !== 'off';
export const toolsEnabled = () => flag('VITE_FEATURE_TOOLS') !== 'off';
